import {
  CommandData,
  CommandWithMarkdown,
  extractCommandData,
  writeCommandDocumentation,
  writeCommandFlagInterface,
  writeCommandUsageExampleFile,
} from './generate.js'
import {writeFile} from '@shopify/cli-kit/node/fs'
import {describe, test, vi, expect} from 'vitest'

vi.mock('@shopify/cli-kit/node/fs')

const testCommand: CommandWithMarkdown = {
  aliases: [],
  args: {},
  flags: {
    flag1: {
      name: 'flag1',
      type: 'option',
      char: 'f',
      description: 'flag description',
    },
    flag2: {
      name: 'flag2',
      type: 'boolean',
      char: 'a',
      description: 'another flag description',
      env: 'FLAG_ENV',
      allowNo: false,
    },
  },
  descriptionWithMarkdown: 'command markdown description',
  description: 'command description',
  summary: 'command summary',
  hidden: false,
  hiddenAliases: [],
  id: 'topic:test-command',
  load: () => Promise.resolve({} as any),
}

const commandData: CommandData = {
  commandName: 'topic test-command',
  fileName: 'topic-test-command',
  interfaceName: 'topictestcommand',
  hasTopic: true,
  topic: 'topic',
  hasFlags: true,
}

describe('extractCommandData', () => {
  test('returns the correct data', () => {
    expect(extractCommandData(testCommand)).toEqual(commandData)
  })
})

describe('writeCommandFlagInterface', () => {
  test('calls writeFile with the correct content', async () => {
    await writeCommandFlagInterface(testCommand, commandData)

    expect(writeFile).toHaveBeenCalledWith(
      expect.stringContaining('docs-shopify.dev/commands/interfaces/topic-test-command.interface.ts'),
      `// This is an autogenerated file. Don't edit this file manually.
export interface topictestcommand {
  /**
   * flag description
   *
   */
  '-f, --flag1 <value>'?: string

  /**
   * another flag description
   * @environment FLAG_ENV
   */
  '-a, --flag2'?: ''
}
`,
    )
  })

  test('calls writeFile with the correct content for a command with no flags', async () => {
    await writeCommandFlagInterface({...testCommand, flags: {}}, commandData)

    expect(writeFile).toHaveBeenCalledWith(
      expect.stringContaining('docs-shopify.dev/commands/interfaces/topic-test-command.interface.ts'),
      `// This is an autogenerated file. Don't edit this file manually.
export interface topictestcommand {

}
`,
    )
  })
})

describe('writeCommandDocs', () => {
  test('calls writeFile with the correct content', async () => {
    await writeCommandDocumentation(testCommand, commandData)

    expect(writeFile).toHaveBeenCalledWith(
      expect.stringContaining('docs-shopify.dev/commands/topic-test-command.doc.ts'),
      `// This is an autogenerated file. Don't edit this file manually.
import {ReferenceEntityTemplateSchema} from '@shopify/generate-docs'

const data: ReferenceEntityTemplateSchema = {
  name: 'topic test-command',
  description: \`command markdown description\`,
  overviewPreviewDescription: \`command summary\`,
  type: 'command',
  isVisualComponent: false,
  defaultExample: {
    codeblock: {
      tabs: [
        {
          title: 'topic test-command',
          code: './examples/topic-test-command.example.sh',
          language: 'bash',
        },
      ],
      title: 'topic test-command',
    },
  },
  definitions: [
  {
    title: 'Flags',
    description: 'The following flags are available for the \`topic test-command\` command:',
    type: 'topictestcommand',
  },
  ],
  category: 'topic',
  related: [
  ],
}

export default data`,
    )
  })
})

describe('writeCommandUsageExampleFile', () => {
  test('calls writeFile with the correct content', async () => {
    await writeCommandUsageExampleFile(testCommand, commandData)

    expect(writeFile).toHaveBeenCalledWith(
      expect.stringContaining('docs-shopify.dev/commands/examples/topic-test-command.example.sh'),
      'shopify topic test-command [flags]',
    )
  })
})
